import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'
import { OrganisationProfileDto } from '../components/Combobox/OrganisationProfileCombobox'

type ReturnProps = {
    loaded: boolean
    organisationProfiles: OrganisationProfileDto[]
    getOrganisationProfile: (key: string) => OrganisationProfileDto
}

export default function useOrganisationProfiles(): ReturnProps {
    const { entities, loaded } = useGlobalContext('organisationProfiles')

    const organisationProfiles: OrganisationProfileDto[] = useMemo(
        () => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [],
        [entities],
    )
    const getOrganisationProfile = (key: string) => entities.find(value => value.key === key)

    return { loaded, organisationProfiles, getOrganisationProfile }
}
